<template>
  <CustomAlert type="info" class="picture-alert">
    <h2 class="mt-0 mb-2 picture-alert__title">Ważne informacje</h2>
    <p class="font-weight-bold">Zamawiasz karty z indywidualnym wizerunkiem po raz pierwszy?</p>
    <p>Upewnij się, że projekt wizerunku został dostarczony i zaakceptowany.</p>
    <br />
    <p class="font-weight-bold">Domawiasz karty z tym samym indywidualnym wizerunkiem?</p>
    <p>Termin dostawy otrzymasz po potwierdzeniu zamówienia.</p>
  </CustomAlert>
</template>

<script>
import CustomAlert from './CustomAlert.vue';

export default {
  name: 'CustomizablePictureAlert',
  components: {
    CustomAlert,
  },
};
</script>

<style lang="scss" scoped>
.picture-alert {
  font-size: 1.3rem;

  p {
    margin: 0;
  }

  &__title {
    font-size: 1.6rem;
    font-weight: 800;
    letter-spacing: -1px;
  }
}
</style>
